var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPackageBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 20.7628V13.9997L10.145 16.2895L14.5 13.8702V25.7775L5 20.7628Z",
    fill: "#EFF3F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.313 20.7603L25.1497 14.0002L20.1497 16.5002L15.6304 13.9141V25.7765L25.313 20.7603Z",
    fill: "#EFF3F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.320611 5.08397L10.0763 0L15.0229 2.61069L13.6326 3.30265L10.1526 1.49995L3.31378 5.08182L6.61199 6.79676L5.08397 7.55725L0.320611 5.08397ZM6.43161 8.2466L5.08397 7.55725L0 10.1221L10.0305 15.1603L15.0229 12.6412L20.1069 15.2519L29.8168 10.1679L24.8712 7.6715L30 5.17557L19.9695 0.0458015L15.0229 2.61069L16.3928 3.31467L16.314 3.35431L15.0649 2.69721L15.8003 3.09044L23.3874 6.99555L23.4722 6.95258L24.8712 7.6715L23.5057 8.36053L23 8.11662L16.314 11.7389L16.5624 11.8644L15.0229 12.6412L13.4991 11.8618L13.7748 11.7269L14.2998 11.9942L14.5308 11.3568L13.7748 11.7269L6.68599 8.11662L6.43161 8.2466ZM6.43161 8.2466L13.4991 11.8618L10.1526 13.4999L3.00002 9.99995L6.43161 8.2466ZM16.5624 11.8644L23.5057 8.36053L27.1531 10.1197L20.2849 13.7446L16.5624 11.8644ZM23.4722 6.95258L16.3928 3.31467L20 1.49995L27.1599 5.08182L23.4722 6.95258ZM6.61199 6.79676L6.68601 6.83525L13.7324 3.35436L13.6326 3.30265L6.61199 6.79676Z",
    fill: "#EFF3F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0229 2.60449L5.08398 7.55106L15.0229 12.635L24.8702 7.64266L15.0229 2.60449Z",
    fill: "#EFF3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPackageBox);
export default __webpack_public_path__ + "static/media/icon_package_box.5dc57dd30cbae465496d3adedb69eeee.svg";
export { ForwardRef as ReactComponent };